import { useNavigate } from "react-router-dom";
import { X, CheckCircle2, Volume2, HelpCircle, FileText } from "lucide-react";
import { use, useEffect, useState } from "react";
import True_False from "../CartComponents/True_False";
import Listen_find from "../CartComponents/Listen_find";
import Answer_question from "../CartComponents/Answer_question";
import Description from "../CartComponents/Description";
import { useSelector } from "react-redux";
import { categoriesExtra } from "../constants/title";
import CategoryButton from "../CommanComponents/CategoryButton";
import useChooseChapter from "../hooks/useChooseChapter";

function ExtraTaskPage() {
  const contentValue = useSelector((state) => state.extra.value);
  const currentActiveId = useSelector((state) => state.extralessanTask.value);
  const dynamicPicture = `/extapicture/${contentValue.picture}`;
  const [tab, settab] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    // contentValue boş veya tanımsız veya uzunluğu 0 ise ana sayfaya yönlendir
    if (!contentValue || contentValue.length === 0) {
      console.log("İçerik boş, ana sayfaya yönlendiriliyor...");
      navigate("/cartPage");
    }
  }, [contentValue, navigate]);
  return (
    <div
      className="flex flex-col   justify-center items-center  gap-4 w-full pb-10"
      style={{ fontFamily: "'Quicksand', sans-serif" }}
    >
      {/* ana icerikleri */}

      {currentActiveId === 1 && (
        <True_False
          true_false={contentValue.true_false}
          picture={dynamicPicture}
          settab={settab}
        />
      )}
      {currentActiveId === 2 && (
        <Listen_find
          listen_find={contentValue.listen_find}
          picture={dynamicPicture}
          settab={settab}
        />
      )}
      {currentActiveId === 3 && (
        <Answer_question
          answer_question={contentValue.answer_question}
          picture={dynamicPicture}
          settab={settab}
        />
      )}
      {/* {currentActiveId === 4 && (
        <Description
          description={contentValue.description}
          picture={dynamicPicture}
          settab={settab}
        />
      )} */}
    </div>
  );
}

export default ExtraTaskPage;
